import { usePutRequest } from './request.legacy'
import { COMPANY } from '../urls'

export function useUpdateCompany() {
    return usePutRequest({ url: COMPANY })
}
